import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      <img src={toAbsoluteUrl('/media/logos/stc_pay_purple_for_home.png')} alt='Start logo' />
      <span>Loading ...</span>
    </div>
  )
}
